module.exports = __webpack_public_path__ + "media/honey-icons/icon-motion-detected-dce7a975.svg";